{
  "nl": {
    "company": {
      "noMembership": {
        "card1": {
          "heading": "Toegang tot licentiegroep activeren",
          "description": "Heeft jouw instelling al een licentie? Voer de 8-cijferige activeringscode in om je toegang te activeren."
        },
        "card2": {
          "heading": "Nog geen licentie?",
          "description": "Met een licentie voor jouw school of onderwijsinstelling kun je fobizz samen met collega's gebruiken. Tip: Een licentie is vaak al vanaf 5 personen de moeite waard!",
          "groupLicenseLink": "Meer over de groepslicentie",
          "consultationLink": "Adviesgesprek inplannen"
        }
      },
      "shell": {
        "school": "Mijn School",
        "workshops": "Interne Workshops",
        "material": "Mijn Materiaal",
        "certificate": "Certificaat",
        "administration": "Licentiebeheer",
        "adminInfo": "Actueel",
        "adminMemberships": "Leden en Licentie",
        "adminEvaluations": "Evaluatie",
        "adminLegals": "Juridisch",
        "internal": "fobizz intern",
        "selectSchool": "School selecteren",
        "switchSchool": "Weergave wijzigen",
        "selectGroup": "Periode selecteren"
      },
      "overview": {
        "endedAlert": "De looptijd van de groep is verstreken. Neem contact op.",
        "internalAnnouncements": "Interne Aankondigingen",
        "internalAnnouncementsAdminInstructions": "Als contactpersoon van deze licentiegroep kun je in dit gebied individuele aanbevelingen plaatsen.",
        "editAnnouncements": "Interne Aankondigingen bewerken",
        "saveAnnouncements": "Bericht bijwerken",
        "cancelAnnouncements": "Annuleren",
        "selectedCourses": "Aanbevelingen",
        "license": "Mijn Schoallicentie",
        "yourContact": "Jouw contactpersoon is | Jouw contactpersonen zijn",
        "licenseHint": "Informatie over jouw licenties vind je onder <a href=\"/profile/licenses\" class=\"fw-semibold\">Mijn Licenties</a>."
      },
      "workshops": {
        "heading": "Interne Workshops",
        "paragraph": "Leer samen met jouw team in onze interne workshops en lezingen.",
        "link": "Interne aanbiedingen ontdekken",
        "current": "Huidige Workshops",
        "past": "Afgelopen Workshops"
      },
      "certificate": {
        "congratulations": "Gefeliciteerd!",
        "courseCompleted": "Je hebt de extra kwalificatie succesvol afgerond.",
        "downloadPrompt": "Download nu je certificaat.",
        "surveyPrompt": "Jouw mening is erg belangrijk voor ons. Geef ons alstublieft kort feedback over de extra kwalificatie.",
        "surveyLink": "Feedback geven",
        "downloadLink": "Downloaden"
      },
      "material": {
        "heading": "Lesmateriaal",
        "fields": {
          "title": "Onderwerp",
          "url": "URL naar mijn resultaat in de fobizz Tools",
          "acceptShared": "Ja, ik ga ermee akkoord mijn bestanden te delen met fobizz en andere docenten binnen het fobizz platform."
        },
        "urlHelp": "Dien hier je lesmateriaal in. Gebruik de sjabloon om je inhoud weer te geven en in te voegen. Belangrijk: Deel de voorbeeldlink.",
        "submit": "Materiaal indienen",
        "edit": "Bewerken",
        "back": "Terug",
        "confirmationHint": "Je project is succesvol bij ons ontvangen. Er wordt geen aparte ontvangstbevestiging per e-mail verzonden."
      },
      "adminLegals": {
        "heading": "Juridisch"
      },
      "adminReports": {
        "heading": "Inschrijvingen",
        "allLicensesEnrollments": "Inschrijving via alle licenties van deze instelling | Inschrijvingen via alle licenties van deze instelling",
        "licenseEnrollments": "Inschrijving via deze licentie | Inschrijvingen via deze licentie",
        "topic": "Opleidingstitel",
        "count": "Aantal"
      },
      "adminEvaluations": {
        "heading": "Evaluatie",
        "intro": "Hier vindt u een samenvattende evaluatie van de feedback binnen deze groep.",
        "noFeedback": "Er is nog niet voldoende feedback voor een evaluatie van de trainingen. Heb nog even geduld.",
        "rating": "Hoe zijn de trainingen gemiddeld beoordeeld?",
        "noRating": "Geen sterbeoordelingen aanwezig.",
        "recommendationScore": "Wat is de gemiddelde aanbevelingsscore voor fobizz?",
        "noRecommendationScore": "Geen aanbevelingsscore aanwezig.",
        "publicComment": "Wat zeggen de leden over de trainingen?",
        "publicCommentTooltip": "Goed om te weten: De recensies zijn vrijwillig gegeven. Openbare recensies worden door slechts een paar personen geschreven.",
        "noPublicComment": "Geen recensies aanwezig.",
        "metabaseDashboard": "Metabase Evaluatiedashboard",
        "schoolFilter": {
          "label": "Filteren op school",
          "allSchools": "Alle scholen"
        }
      },
      "adminMemberships": {
        "heading": "Leden en Licentie",
        "inviteMembers": "Leden uitnodigen",
        "manageMembers": "Leden beheren",
        "searchPlaceholder": "Naam of e-mail...",
        "search": "Zoeken...",
        "copySuccess": "Link gekopieerd!",
        "members": "Lid | Leden",
        "summary": {
          "groupAdmin": "fobizz Coördinatoren",
          "manageAdmins": "Beheerders beheren",
          "orderEndsAt": "Einde van de Schoallicentie",
          "package": "Licentiepakket",
          "requestMoreLicenses": "Extra licenties aanvragen"
        },
        "activationCode": {
          "title": "Activeringscode voor nieuwe leden",
          "description": "Met deze code kunnen alle collega's via {url} lid worden van deze licentiegroep.",
          "copyButton": "Link inclusief code kopiëren"
        },
        "invitationOptions": {
          "title": "Andere opties om nieuwe leden uit te nodigen voor de groep:",
          "emailCard": "Uitnodiging per e-mail",
          "posterCard": "Aankondiging afdrukken",
          "linkCard": "Link inclusief code kopiëren"
        },
        "table": {
          "name": "Naam",
          "email": "E-mailadres",
          "status": "Status",
          "createdAt": "Toegetreden op",
          "actions": "Acties"
        },
        "actions": {
          "extend": "Verlengen",
          "remove": "Verwijderen"
        },
        "confirm": {
          "extend": {
            "title": "Looptijd verlengen?",
            "text": "De looptijd voor {name} wordt verlengd. Een verlenging komt overeen met één licentie."
          },
          "remove": {
            "title": "Lid verwijderen?",
            "text": "Deze actie kan niet ongedaan worden gemaakt. {name} wordt uit de groep verwijderd en verliest de toegang tot de schoallicentie."
          }
        },
        "error": {
          "actionFailed": "De actie kon niet worden uitgevoerd. Een herlading van de pagina toont de huidige status.",
          "invitationFailed": "De uitnodiging kon niet worden verzonden. Een herlading van de pagina toont de huidige status."
        },
        "pagination": {
          "previous": "Terug",
          "next": "Verder",
          "page": "Pagina {current} van {total}"
        },
        "emailModal": {
          "title": "Uitnodiging per e-mail verzenden",
          "placeholder": "Alle e-mailadressen invoeren",
          "hint": "Voer de e-mailadressen in van alle personen die een uitnodiging moeten ontvangen.",
          "helpInvalidAddresses": "Ongeldige adressen worden rood gemarkeerd.",
          "helpMailingLists": "Distributielijstadressen zijn niet geschikt.",
          "submit": "Verzenden"
        }
      },
      "license": {
        "courses": {
          "title": "Scholings-Schullicentie",
          "description": "Toegang tot alle fobizz-scholingen, inclusief AI-scholingen",
          "linkLabel": "Naar de scholingscatalogus"
        },
        "tools": {
          "title": "Tools-Schullicentie",
          "description": "Toegang tot fobizz-tools voor de les, inclusief AI-tools en AI-klaslokalen voor leerlingen",
          "linkLabel": "Tools-Schullicentie"
        },
        "toTeach": {
          "title": "to teach-Schullicentie",
          "description": "Pro-toegang voor het team voor to teach: Differentieerbare lesvoorbereiding en materialen",
          "linkLabel": "to teach-Schullicentie"
        },
        "status": {
          "active": "actief",
          "trial": "Proeflicentie",
          "exceeded": "Verlopen",
          "nonActive": "niet actief",
          "confirmed": "bevestigd"
        },
        "activeUntil": "Toegang geldig tot",
        "activeFrom": "Toegang geldig van {startDate} tot {endDate}",
        "generalActiveUntil": "Licentie geldig tot",
        "upgradeText": "Bijboeken voor {months} maanden:",
        "requestUpgrade": "Uitbreiding aanvragen",
        "renewalHeadline": "Verlengingsmelding",
        "renewalText": "Voor de groep \"{groupName}\" is al een verlenging geboekt. De nieuwe licentie voor {licenses} start op {startsAt}."
      },
      "membershipExceeded": {
        "member": {
          "heading": "Je licentie is helaas beëindigd.",
          "paragraph": "Praat met de contactpersoon van jouw school en informeer hoe jullie als school fobizz verder kunnen gebruiken.",
          "paragraphWithContact": "Praat met de contactpersoon van jouw school ({contactNames}) en informeer hoe jullie als school fobizz verder kunnen gebruiken. | Praat met de contactpersonen van jouw school ({contactNames}) en informeer hoe jullie als school fobizz verder kunnen gebruiken.",
          "hintText": "Tip: Alternatief vind je hier informatie over",
          "hintLink": "individuele abonnementen",
          "hintSuffix": "voor persoonlijk gebruik."
        },
        "admin": {
          "heading": "Uw licentie is helaas beëindigd.",
          "paragraph": "Als contactpersoon voor de school kunt u nog steeds de {reportsLink} bezoeken. Daar kunt u ook de {extendLink}.",
          "reportsLink": "Beheeromgeving",
          "extendLink": "Schullicentie verlengen"
        },
        "salesContact": {
          "heading": "Welkom in de beheeromgeving van uw school",
          "textPrefix": "Ik adviseer u graag over al uw vragen met betrekking tot uw schoolllicentie. U kunt mij bereiken via",
          "textMiddle": "Als u hier een",
          "calendarLink": "telefoonafspraak",
          "textSuffix": "kiest, bel ik u terug."
        }
      },
      "csv": "CSV exporteren",
      "print": "Afdrukken",
      "platformStats": {
        "allEnrollmentsCount": "Inschrijving via alle licenties | Inschrijvingen via alle licenties",
        "membershipsCount": "Lid | Leden",
        "continueUsingPart": "willen fobizz verder gebruiken"
      },
      "toolsStats": {
        "digitalTools": "gebruikte tools en gemaakte materialen",
        "pinboardsAndTeacherboards": "Prikborden en borden",
        "wordcloudsAndWebsites": "Woordwolken en websites",
        "worksheetsAndSurveys": "Werkbladen en enquêtes",
        "texteditor": "Tekstdocument | Tekstdocumenten",
        "audiorecords": "Audio-opnames",
        "screenAndVideorecorder": "Video-opnames",
        "linksAndFilesharing": "Kortelinks en bestanden",
        "aiTools": "verzonden AI-prompts",
        "sharedSpaces": "aangemaakte AI-klaslokalen",
        "sharedSpaceLinkInviteesCount": "Leerlingen in AI-klaslokalen"
      }
    }
  }
}
